import { sectionConfig } from "~/config/_pages/home/whyfig";
import type { BucketIcon } from "~/types/icon";
import ShowcaseUI from "~/components/ui/_home/showcase";

export default function WhyfigSection() {
  return (
    <ShowcaseUI>
      <ShowcaseUI.Heading>
        <ShowcaseUI.Suptitle label={sectionConfig.suptitle} />
        <ShowcaseUI.Title label={sectionConfig.title} />
      </ShowcaseUI.Heading>
      <ShowcaseUI.Body>
        {sectionConfig.reasons.map((item, i) => (
          <ShowcaseUI.Item
            key={i}
            title={item.title}
            caption={item.caption}
            icon={item.icon as BucketIcon}
            index={i}
          />
        ))}
      </ShowcaseUI.Body>
    </ShowcaseUI>
  );
}
